import { colorPresets, getColorDomain } from '@rawgraphs/rawgraphs-core'

export function getCompatibleInterpolators(scaleType, colorDataset, colorDataType) {
  const presets = colorPresets[scaleType] || {}
  const interpolators = Object.keys(presets)

  if (scaleType !== 'ordinal' || !colorDataset?.length || !colorDataType) {
    return interpolators
  }

  const domain = getColorDomain(colorDataset, colorDataType, scaleType)
  if (domain.length >= 2) {
    return interpolators
  }

  return interpolators.filter((interpolator) =>
    Array.isArray(presets[interpolator]?.value)
  )
}
